module.exports = __webpack_public_path__ + "img/mat_1.5bd7eb10.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":1200,"height":894,"variants":[{"file":"img/mat_1-480w.e8d316ef07e7.webp","width":480},{"file":"img/mat_1-960w.6eb2d823d455.webp","width":960},{"file":"img/mat_1-1200w.0046e383c1dc.webp","width":1200}]};
}